export const bannerIcon = [
  '65 65',
  `<g id="Grupo_251" data-name="Grupo 251" transform="matrix(3.020351, 0, 0, 3.444994, -47.74469, -685.085327)" opacity="0.5" style="">
    <g id="Rectángulo_330" data-name="Rectángulo 330" transform="matrix(1, 0, 0, 1.146596, 16, 199.812592)" fill="none" stroke="#47b2e5" stroke-width="1.6" style="">
      <rect width="21" height="15" rx="5" stroke="none"/>
      <rect x="0.8" y="0.8" width="19.4" height="13.4" rx="4.2" fill="none"/>
    </g>
    <line id="Línea_48" data-name="Línea 48" x2="5" transform="translate(20.5 208.5)" fill="none" stroke="#47b2e5" stroke-width="1.6" style="stroke-linecap: round;"/>
    <line id="Línea_49" data-name="Línea 49" x2="5" transform="translate(20.5 211.5)" fill="none" stroke="#47b2e5" stroke-width="1.6" style="stroke-linecap: round;"/>
  </g>`
];